import { FormGroup } from '@angular/forms';

export function checkConfirm(group: FormGroup, anotherControleName: string) {
  const anotherValue = group.parent?.get(anotherControleName).value;
  if (!anotherValue)
    return { notSame: true };
  const confirm = group.value;
  return anotherValue === confirm ? null : { notSame: true };
}

export const validationPattern = {
  email: /^((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})+(?:.nvr-)?))/,
  mobile: /^(09\d{9})$/i
}
